import { Inject, ISimpleControllerConfiguration, SimpleBaseController } from '@denishussar/html5-game-engine';
import { GameModel, GameStateEnum } from '../../../Models/GameModel';
import { GameLogic } from '../../../Logic/GameLogic';
import { FriendsListRowController } from './FriendsListRowController';


export interface IFriendsListListControllerOptions {
}

export class FriendsListListController extends SimpleBaseController {
    $model: GameModel;

    private _mask: PIXI.Sprite;
    private _bounds: {width: number, height: number};
    private _scrollContainer: PIXI.Container;
    private _items: FriendsListRowController[] = [];

    public constructor(@Inject private _options: IFriendsListListControllerOptions,
                       @Inject private _gameLogic: GameLogic) {
        super('RootController');

        this._bounds = {width: 1220, height: 576};
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return {
            childControllers: {

            },
        };
    }

    set friends(list: any[]) {
        if (this._items.length > 0) {
            this._items.forEach((item) => {
                this.removeChildController(item)
            })
        }
        this._items = list.map((friend:any, index):FriendsListRowController => {
            this.addChildController({
                controller: FriendsListRowController,
                options: friend,
            }, `friend_list__row_${index}`);
            this.$childControllers.get(`friend_list__row_${index}`).display.y = 100 * index;
            this._scrollContainer.addChild(this.$childControllers.get(`friend_list__row_${index}`).display);
            return this.$childControllers.get(`friend_list__row_${index}`);
        })
    }

    protected async onInitialize() {
        this._mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._mask.width = this._bounds.width;
        this._mask.height = this._bounds.height;
        this._mask.y = -28;
        this.display.mask = this._mask;
        this.display.addChild(this._mask);

        this._scrollContainer = new PIXI.Container;
        this.display.addChild(this._scrollContainer);
    }

    public setPosition(value) {
        if (this._scrollContainer.height <= this._bounds.height) return;
        this._scrollContainer.y = (this._bounds.height - this._scrollContainer.height - 28 * 2) * value;
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {

    }

    protected onUpdate(frameRate: number) {

    }
}
